import React, { useEffect, useState } from 'react';
import { Line } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  LineElement,
  LinearScale,
  Title,
  Tooltip,
  Legend,
  PointElement,
} from 'chart.js';
import toast from 'react-hot-toast';
import { fetchSalesReports } from '../../utils/api/api';

ChartJS.register(LineElement, LinearScale, Title, Tooltip, Legend, PointElement);

const ActualPlanned = () => {
  const [monthlySales, setMonthlySales] = useState([]);

  const getMonthlySales = async () => {
    try {
      const response = await fetchSalesReports();
      setMonthlySales(response.monthlySales);
    } catch (error) {
      toast.error("Failed to get report");
    }
  };

  useEffect(() => {
    getMonthlySales();
  }, []);

  const labels = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const aggregatedSales2023 = Array(12).fill(0);
  const aggregatedSales2024 = Array(12).fill(0);

  monthlySales?.forEach((sale) => {
    const monthIndex = new Date(`${sale.month}-01`).getMonth();
    const year = new Date(`${sale.month}-01`).getFullYear();

    if (year === 2023) {
      aggregatedSales2023[monthIndex] = parseFloat(sale.totalSales);
    } else if (year === 2024) {
      aggregatedSales2024[monthIndex] = parseFloat(sale.totalSales);
    }
  });

  const data = {
    labels,
    datasets: [
      {
        label: '2023 Sales',
        data: aggregatedSales2023,
        borderColor: '#4A90E2',
        backgroundColor: 'rgba(74, 144, 226, 0.2)',
        fill: true,
        tension: 0.4,
        pointRadius: 0,
      },
      {
        label: '2024 Sales',
        data: aggregatedSales2024,
        borderColor: '#F8A81B',
        backgroundColor: (context) => {
          const chart = context.chart;
          const { ctx, chartArea } = chart;

          if (!chartArea) return null;

          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, '#F7F7F7');
          gradient.addColorStop(1, '#F8B236');
          return gradient;
        },
        fill: true,
        tension: 0.4,
        pointRadius: 0,
      },
    ],
  };

  const options = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        grid: {
          display: false,
        },
      },
      y: {
        grid: {
          color: '#f8f8f8',
        },
        ticks: {
          callback: function (value) {
            return `${(value / 1000).toLocaleString()}k`;
          },
        },
      },
    },
    plugins: {
      legend: {
        display: true,
        position: 'top',
      },
      title: {
        display: true,
        text: 'Annual Sales Comparison (2023 vs 2024)',
        font: {
          size: 18,
          weight: '500',
        },
        color: '#0E113C',
        align: 'start',
      },
    },
  };

  return (
    <div style={{ height: '300px' }} className="w-full bg-[#fff] rounded-lg p-2 flex flex-col">
      <Line data={data} options={options} />
    </div>
  );
};

export default ActualPlanned;
